import { Workshop } from '../../../_shared/models/workshop.model';
import { WorkOrderSource, WorkOrderServiceType, WorkOrderPriority, WorkOrderStatus, WorkOrderRequestStatus } from '../enums/work-order.enum';
import { WorkOrderRequestResponse } from '../models/work-order-requests-overview.models';
import { WorkOrderResponse } from '../models/work-orders-overview.models';
import { BreakdownAnalysisResponse } from '../../maintenance-overview/models/maintenance-overview.model';

/** Technician data from API */
export interface Technician {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  specialization?: string;
  isAvailable?: boolean;
}

// Mock data for Technicians
export const TECHNICIANS_MOCK: Technician[] = [
  { id: 1, name: 'Alexander Manzini', email: 'alexander.m@example.com', specialization: 'Engine & Transmission', isAvailable: true },
  { id: 2, name: 'John Doe', email: 'john.doe@example.com', specialization: 'Electrical Systems', isAvailable: true },
  { id: 3, name: 'Jane Smith', email: 'jane.smith@example.com', specialization: 'Brakes & Suspension', isAvailable: true },
  { id: 4, name: 'Michael Brown', email: 'michael.b@example.com', specialization: 'General Maintenance', isAvailable: false },
  { id: 5, name: 'Sarah Johnson', email: 'sarah.j@example.com', specialization: 'Tyres & Alignment', isAvailable: true },
  { id: 6, name: 'David Wilson', email: 'david.w@example.com', specialization: 'Fuel Systems', isAvailable: true },
  { id: 7, name: 'Emily Davis', email: 'emily.d@example.com', specialization: 'Hydraulics', isAvailable: true },
  { id: 8, name: 'Chris Lee', email: 'chris.l@example.com', specialization: 'Cooling Systems', isAvailable: true },
  { id: 9, name: 'Anna Martinez', email: '', specialization: 'Exhaust Systems', isAvailable: false },
  { id: 10, name: 'James Taylor', email: '', specialization: 'Diagnostics', isAvailable: true }
];

// Mock data for Work Order Requests tab
export const WORK_ORDER_REQUESTS_MOCK: WorkOrderRequestResponse[] = [
  {
    id: 1,
    workOrderId: 'WO-031225-01',
    assetId: 1,
    assetName: 'TRK - 001',
    dateCreated: new Date('2026-01-03T12:59:00'),
    source: WorkOrderSource.CanBus,
    workType: 'Oil change and basic maintenance',
    workshopName: 'Workshop A',
    estimatedCost: 15000,
    estimatedTime: '4 Hours',
    priority: WorkOrderPriority.Low,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 2,
    workOrderId: 'WO-031225-02',
    assetId: 2,
    assetName: 'TRK - 008',
    dateCreated: new Date('2026-01-05T12:59:00'),
    source: WorkOrderSource.DriverApp,
    workType: 'Transmission Service',
    workshopName: 'Workshop B',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.Low,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 3,
    workOrderId: 'WO-031225-03',
    assetId: 3,
    assetName: 'TRK - 002',
    dateCreated: new Date('2026-01-19T12:59:00'),
    source: WorkOrderSource.ComplianceApp,
    workType: 'Tyre Rotation & Alignment',
    workshopName: 'Workshop B',
    estimatedCost: 15000,
    estimatedTime: '1 - 2 Hours',
    priority: WorkOrderPriority.Medium,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 4,
    workOrderId: 'WO-031225-04',
    assetId: 4,
    assetName: 'TRK - 006',
    dateCreated: new Date('2026-01-26T12:59:00'),
    source: WorkOrderSource.CanBus,
    workType: 'Major Service',
    workshopName: 'TruckFix - Benoni',
    estimatedCost: 15000,
    estimatedTime: '14 Hours (1.5 - 2 days)',
    priority: WorkOrderPriority.High,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 5,
    workOrderId: 'WO-031225-05',
    assetId: 5,
    assetName: 'TRK - 007',
    dateCreated: new Date('2026-01-01T12:59:00'),
    source: WorkOrderSource.OEM,
    workType: 'Engine Oil & Filter Change',
    workshopName: 'Workshop C',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.Medium,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 6,
    workOrderId: 'WO-031225-06',
    assetId: 5,
    assetName: 'TRK - 005',
    dateCreated: new Date('2026-01-11T12:59:00'),
    source: WorkOrderSource.OEM,
    workType: 'Engine Oil & Filter Change',
    workshopName: 'Workshop C',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.High,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 7,
    workOrderId: 'WO-031225-07',
    assetId: 5,
    assetName: 'TRK - 003',
    dateCreated: new Date('2026-01-09T12:59:00'),
    source: WorkOrderSource.DriverApp,
    workType: 'Engine Oil & Filter Change',
    workshopName: 'Workshop C',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.High,
    status: WorkOrderRequestStatus.Pending
  },
  {
    id: 8,
    workOrderId: 'WO-031225-08',
    assetId: 5,
    assetName: 'TRK - 004',
    dateCreated: new Date('2026-01-14T12:59:00'),
    source: WorkOrderSource.DriverApp,
    workType: 'Engine Oil & Filter Change',
    workshopName: 'Workshop C',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.Medium,
    status: WorkOrderRequestStatus.Pending
  }
];

// Mock data for Work Orders tab
export const WORK_ORDERS_MOCK: WorkOrderResponse[] = [
  {
    id: 1,
    workOrderId: 'WO-031225-01',
    assetId: 1,
    assetName: 'TRK - 001',
    source: WorkOrderSource.CanBus,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Oil change and basic maintenance',
    workshopId: 1,
    workshopName: 'Workshop A',
    technicianId: 1,
    technicianName: 'Alexander Manzini',
    estimatedCost: 15000,
    estimatedTime: '4 Hours',
    priority: WorkOrderPriority.Low,
    scheduledDate: new Date('2026-01-30T12:59:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 2,
    workOrderId: 'WO-031225-02',
    assetId: 1,
    assetName: 'TRK - 005',
    source: WorkOrderSource.CanBus,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Oil change and basic maintenance',
    workshopId: 1,
    workshopName: 'Workshop A',
    technicianId: 2,
    technicianName: 'John Doe',
    estimatedCost: 15000,
    estimatedTime: '4 Hours',
    priority: WorkOrderPriority.Low,
    scheduledDate: new Date('2026-02-03T12:59:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 3,
    workOrderId: 'WO-031225-03',
    assetId: 2,
    assetName: 'TRK - 003',
    source: WorkOrderSource.DriverApp,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Transmission Service',
    workshopId: 2,
    workshopName: 'Workshop B',
    technicianId: 3,
    technicianName: 'Jane Smith',
    estimatedCost: 15000,
    estimatedTime: '2 - 3 Hours',
    priority: WorkOrderPriority.Medium,
    scheduledDate: new Date('2026-01-07T12:59:00'),
    status: WorkOrderStatus.Completed
  },
  {
    id: 4,
    workOrderId: 'WO-031225-04',
    assetId: 3,
    assetName: 'TRK - 002',
    source: WorkOrderSource.ComplianceApp,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Tyre Rotation & Alignment',
    workshopId: 2,
    workshopName: 'Workshop B',
    technicianId: 1,
    technicianName: 'Alexander Manzini',
    estimatedCost: 15000,
    estimatedTime: '1 - 2 Hours',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-01-29T12:59:00'),
    status: WorkOrderStatus.InProgress
  },
  {
    id: 5,
    workOrderId: 'WO-031225-05',
    assetId: 4,
    assetName: 'TRK - 006',
    source: WorkOrderSource.CanBus,
    serviceType: WorkOrderServiceType.MajorService,
    workType: 'Major Service',
    workshopId: 3,
    workshopName: 'TruckFix - Benoni',
    technicianId: 4,
    technicianName: 'Michael Brown',
    estimatedCost: 15000,
    estimatedTime: '14 Hours (1.5 - 2 days)',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-01-11T12:59:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 6,
    workOrderId: 'WO-031225-06',
    assetId: 6,
    assetName: 'TRK - 004',
    source: WorkOrderSource.ComplianceApp,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Brake system (linings, pads)',
    workshopId: 5,
    workshopName: 'Durban Harbour Service',
    technicianId: 2,
    technicianName: 'John Doe',
    estimatedCost: 20000,
    estimatedTime: '45 - 60 Minutes',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-01-28T10:30:00'),
    status: WorkOrderStatus.InProgress
  },
  {
    id: 7,
    workOrderId: 'WO-031225-07',
    assetId: 7,
    assetName: 'TRK - 007',
    source: WorkOrderSource.OEM,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Engine Oil & Filter Change',
    workshopId: 4,
    workshopName: 'Cape Town Logistics Hub',
    technicianId: 5,
    technicianName: 'Sarah Johnson',
    estimatedCost: 8500,
    estimatedTime: '2 Hours',
    priority: WorkOrderPriority.Low,
    scheduledDate: new Date('2026-02-05T09:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 8,
    workOrderId: 'WO-031225-08',
    assetId: 8,
    assetName: 'TRK - 008',
    source: WorkOrderSource.DriverApp,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Fuel System Inspection',
    workshopId: 6,
    workshopName: 'Gaborone Fleet Hub',
    technicianId: 6,
    technicianName: 'David Wilson',
    estimatedCost: 12000,
    estimatedTime: '3 - 4 Hours',
    priority: WorkOrderPriority.Medium,
    scheduledDate: new Date('2026-02-08T14:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 9,
    workOrderId: 'WO-031225-09',
    assetId: 9,
    assetName: 'VAN - 001',
    source: WorkOrderSource.CanBus,
    serviceType: WorkOrderServiceType.MajorService,
    workType: 'Complete Engine Overhaul',
    workshopId: 8,
    workshopName: 'Lagos Service Depot',
    technicianId: 7,
    technicianName: 'Emily Davis',
    estimatedCost: 45000,
    estimatedTime: '2 - 3 Days',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-02-12T08:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 10,
    workOrderId: 'WO-031225-10',
    assetId: 10,
    assetName: 'VAN - 002',
    source: WorkOrderSource.ComplianceApp,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Air Filter Replacement',
    workshopId: 10,
    workshopName: 'Nairobi Central Workshop',
    technicianId: 8,
    technicianName: 'Chris Lee',
    estimatedCost: 5500,
    estimatedTime: '1 Hour',
    priority: WorkOrderPriority.Low,
    scheduledDate: new Date('2026-02-15T11:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 11,
    workOrderId: 'WO-031225-11',
    assetId: 11,
    assetName: 'TRK - 009',
    source: WorkOrderSource.OEM,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Hydraulic System Failure',
    workshopId: 12,
    workshopName: 'Lusaka Heavy Duty Centre',
    technicianId: 10,
    technicianName: 'James Taylor',
    estimatedCost: 35000,
    estimatedTime: '6 - 8 Hours',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-01-05T07:30:00'),
    status: WorkOrderStatus.Completed
  },
  {
    id: 12,
    workOrderId: 'WO-031225-12',
    assetId: 12,
    assetName: 'TRK - 010',
    source: WorkOrderSource.DriverApp,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Cooling System Service',
    workshopId: 7,
    workshopName: 'Maun Express Service',
    technicianId: 3,
    technicianName: 'Jane Smith',
    estimatedCost: 18000,
    estimatedTime: '4 - 5 Hours',
    priority: WorkOrderPriority.Medium,
    scheduledDate: new Date('2026-01-30T10:00:00'),
    status: WorkOrderStatus.InProgress
  },
  {
    id: 13,
    workOrderId: 'WO-031225-13',
    assetId: 13,
    assetName: 'VAN - 003',
    source: WorkOrderSource.CanBus,
    serviceType: WorkOrderServiceType.MinorService,
    workType: 'Battery Replacement',
    workshopId: 9,
    workshopName: 'Abuja Highway Workshop',
    technicianId: 1,
    technicianName: 'Alexander Manzini',
    estimatedCost: 7500,
    estimatedTime: '1 - 2 Hours',
    priority: WorkOrderPriority.Low,
    scheduledDate: new Date('2026-02-18T13:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 14,
    workOrderId: 'WO-031225-14',
    assetId: 14,
    assetName: 'TRK - 011',
    source: WorkOrderSource.ComplianceApp,
    serviceType: WorkOrderServiceType.MajorService,
    workType: 'Gearbox Rebuild',
    workshopId: 11,
    workshopName: 'Mombasa Coastal Service',
    technicianId: 4,
    technicianName: 'Michael Brown',
    estimatedCost: 55000,
    estimatedTime: '3 - 4 Days',
    priority: WorkOrderPriority.High,
    scheduledDate: new Date('2026-01-08T08:00:00'),
    status: WorkOrderStatus.Open
  },
  {
    id: 15,
    workOrderId: 'WO-031225-15',
    assetId: 15,
    assetName: 'TRK - 012',
    source: WorkOrderSource.OEM,
    serviceType: WorkOrderServiceType.IntermediateService,
    workType: 'Suspension Inspection & Repair',
    workshopId: 13,
    workshopName: 'Kitwe Mining Support',
    technicianId: 5,
    technicianName: 'Sarah Johnson',
    estimatedCost: 22000,
    estimatedTime: '5 - 6 Hours',
    priority: WorkOrderPriority.Medium,
    scheduledDate: new Date('2026-02-20T09:30:00'),
    status: WorkOrderStatus.Open
  }
];

// Mock Workshop data for the workshop filter dropdown
export const WORKSHOP_MOCK: Workshop[] = [
  { id: 1, name: 'Workshop A', country: 'South Africa' },
  { id: 2, name: 'Workshop B', country: 'South Africa' },
  { id: 3, name: 'TruckFix - Benoni', country: 'South Africa' },
  { id: 4, name: 'Cape Town Logistics Hub', country: 'South Africa' },
  { id: 5, name: 'Durban Harbour Service', country: 'South Africa' },
  { id: 6, name: 'Gaborone Fleet Hub', country: 'Botswana' },
  { id: 7, name: 'Maun Express Service', country: 'Botswana' },
  { id: 8, name: 'Lagos Service Depot', country: 'Nigeria' },
  { id: 9, name: 'Abuja Highway Workshop', country: 'Nigeria' },
  { id: 10, name: 'Nairobi Central Workshop', country: 'Kenya' },
  { id: 11, name: 'Mombasa Coastal Service', country: 'Kenya' },
  { id: 12, name: 'Lusaka Heavy Duty Centre', country: 'Zambia' },
  { id: 13, name: 'Kitwe Mining Support', country: 'Zambia' }
];

// ============================================
// KPI Breakdown Modal Mock Data
// ============================================

// Mock data for Total Work Orders breakdown analysis
export const WORK_ORDER_BREAKDOWN_MOCK: BreakdownAnalysisResponse[] = [
  {
    factor: 'Total Work Orders',
    previousValue: '2',
    currentValue: '6',
    change: '+200.00%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Completed Work Orders',
    previousValue: '1 650',
    currentValue: '1 750',
    change: '+6.06%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Minor Service',
    previousValue: '1 000',
    currentValue: '1 000',
    change: '0.00%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Major Service',
    previousValue: '800',
    currentValue: '950',
    change: '+18.75%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Total Hours',
    previousValue: '3 500 hrs',
    currentValue: '3 600 hrs',
    change: '+2.86%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Total Cost',
    previousValue: 'R 16 000 000',
    currentValue: 'R 16 500 000',
    change: '+3.13%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];

// Mock data for Overdue breakdown analysis
export const OVERDUE_BREAKDOWN_MOCK: BreakdownAnalysisResponse[] = [
  {
    factor: 'Total Maintenances',
    previousValue: '1 600',
    currentValue: '1 650',
    change: '+3.13%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Total Hours',
    previousValue: '3 500 hrs',
    currentValue: '3 600 hrs',
    change: '+2.86%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Total Cost',
    previousValue: 'R 16 000 000',
    currentValue: 'R 16 500 000',
    change: '+3.13%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];

// Mock data for In Progress breakdown analysis
export const IN_PROGRESS_BREAKDOWN_MOCK: BreakdownAnalysisResponse[] = [
  {
    factor: 'Total Maintenances',
    previousValue: '1 200',
    currentValue: '1 250',
    change: '+4.17%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Total Hours',
    previousValue: '2 800 hrs',
    currentValue: '2 900 hrs',
    change: '+3.57%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Average Hours',
    previousValue: '2.5 hrs',
    currentValue: '2.6 hrs',
    change: '+4.00%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Total Cost',
    previousValue: 'R 12 000 000',
    currentValue: 'R 12 500 000',
    change: '+4.17%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];

// Mock data for Average Resolution Time breakdown analysis
export const AVG_RESOLUTION_BREAKDOWN_MOCK: BreakdownAnalysisResponse[] = [
  {
    factor: 'Total Hours',
    previousValue: '500 hrs',
    currentValue: '550 hrs',
    change: '+10.00%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Avg. Time per asset',
    previousValue: '1.5 hrs',
    currentValue: '1.6 hrs',
    change: '+6.67%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Avg. Downtime per Asset',
    previousValue: '3 hrs',
    currentValue: '3.2 hrs',
    change: '+6.67%',
    impactOnEfficiency: 'Decreased on Efficiency'
  },
  {
    factor: 'Avg. Time (Preventative)',
    previousValue: '2 hrs',
    currentValue: '2.1 hrs',
    change: '+5.00%',
    impactOnEfficiency: 'Increased on Efficiency'
  },
  {
    factor: 'Avg. Time (Reactive)',
    previousValue: '4 hrs',
    currentValue: '4.5 hrs',
    change: '+12.50%',
    impactOnEfficiency: 'Decreased on Efficiency'
  }
];
